import React from 'react';
import { Grid, Typography, Box } from '@mui/material';
import { basic } from "../../themes/basic";


const AccountLinkingInfo = ({ otp }) => {
  return (
    <Box sx={{ p: 1 }}>
      {/* Success Message */}
      <Typography sx={{ fontWeight: 'bold', lineHeight:"18px", fontFamily: basic.fontFamily, fontSize: basic.contentFontSize, color: 'green', }}>
       <br />
        Your password has been successfully reset.
      </Typography>

      <Typography sx={{ lineHeight:"18px", fontFamily: basic.fontFamily, fontSize: basic.contentFontSize, color: 'black', }}>
        <br />Please copy the OTP below to create a new password and link your account.
      </Typography>

      {/* Info Rows */}
      <Grid container style={{ paddingTop:"10px"}}>
        
        {/* OTP */}
        <Grid item xs={6} style={{ border:"1px solid #ccc",padding:"5px 5px"}}>
          <Typography sx={{ fontWeight: 'bold', fontFamily: basic.fontFamily, fontSize: basic.contentFontSize }}>OTP</Typography>
        </Grid>
        <Grid item xs={6} style={{ border:"1px solid #ccc", borderLeft:"0px solid",padding:"5px 5px"}}>
          <Typography sx={{ fontFamily: basic.fontFamily, fontSize: basic.contentFontSize }}>{otp}</Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AccountLinkingInfo;
